module.exports = __webpack_public_path__ + "media/images/channels/gynecology-36fb57ca5b19776ed62378d934a46387.jpg";